import styled from 'styled-components';

import PageTitle from '@/components/PageTitle/PageTitle';

import TerminologyPageHeaderMeta from './TerminologyPageHeaderMeta';

const TerminologyPage = () => {
    return (
        <StyledPageContainer>
            <TerminologyPageHeaderMeta />
            <div>
                <PageTitle title="Auction Terminology" />
                <h5>
                    <strong>Absentee Bidder:</strong>
                </h5>
                <p>
                    A person who may not attend the sale but submits, in advance, a written or oral bid that is the top
                    price he/she will pay for a given property.
                </p>

                <h5>
                    <strong>Absentee Bid/Proxy Bid:</strong>
                </h5>
                <p>
                    A bid on an item that a bidder leaves without being physically present. LiveAuctioneers allows a
                    bidder to leave a bid on any item listed online by clicking &quot;Bid Now&quot; and entering a bid
                    amount. All bids are kept confidential from the auctioneer and other bidders. At the time of the
                    live auction, the bidding system will attempt to execute your bid at the lowest cost possible.
                </p>

                <h5>
                    <strong>Appraisal:</strong>
                </h5>
                <p>The act or process of estimating value. </p>

                <h5>
                    <strong>&quot;As Is:&quot;</strong>
                </h5>
                <p>
                    Also known as &quot;as is, where is&quot; and &quot;in its present condition.&quot; Typically, this
                    is a sign that no return privileges will be granted.
                </p>

                <h5>
                    <strong>Auction:</strong>
                </h5>
                <p>
                    A method of selling property in a public forum through open and competitive bidding. Also referred
                    to as: public auction, auction sale or sale.{' '}
                </p>

                <h5>
                    <strong>Auctioneer:</strong>
                </h5>
                <p>
                    The person whom the seller engages to direct, conduct, or be responsible for a sale by auction. This
                    person may or may not actually &quot;call&quot; or &quot;cry&quot; the auction.{' '}
                </p>

                <h5>
                    <strong>Auction Block:</strong>
                </h5>
                <p>
                    The podium or raised platform where the auctioneer stands while conducting the auction.
                    &quot;Placing (an item) on the auction block&quot; means to sell something at auction.{' '}
                </p>

                <h5>
                    <strong>Bid:</strong>
                </h5>
                <p>
                    A prospective buyer&apos;s indication or offer of a price he/she will pay to purchase property at
                    auction. Bids are usually in standardized increments established by the auctioneer.
                </p>

                <h5>
                    <strong>Bid Caller:</strong>
                </h5>
                <p>
                    The person who actually &quot;calls,&quot; &quot;cries&quot; or &quot;auctions&quot; the property at
                    an auction, recognizing bidders and acknowledging the highest bidder. Commonly known as the
                    auctioneer.
                </p>

                <h5>
                    <strong>Bid History:</strong>
                </h5>
                <p>A historical list of all the bids made on a particular auction during or after the auction.</p>

                <h5>
                    <strong>Bid Increments:</strong>
                </h5>
                <p>
                    The standardized amount an item increases in price after each new bid. The auction service sets the
                    increment, which rises according to the present high bid value of an item.{' '}
                </p>

                <h5>
                    <strong>Bidder (Paddle) Number:</strong>
                </h5>
                <p>The number issued to each person who registers at an auction. </p>

                <h5>
                    <strong>Buyer&apos;s Premium:</strong>
                </h5>
                <p>
                    An additional service charge, for which the buyer is responsible, may be added to the price of sold
                    items. If so, this will be indicated on the item page.
                </p>

                <h5>
                    <strong>Catalog or Brochure:</strong>
                </h5>
                <p>
                    A publication advertising and describing the property(ies) available for sale at public auction,
                    often including photographs, property descriptions and the terms and conditions of the sale.{' '}
                </p>

                <h5>
                    <strong>Clerk:</strong>
                </h5>
                <p>
                    The person employed by the principal auctioneer or auction firm to record what is sold, to whom and
                    for what price.{' '}
                </p>

                <h5>
                    <strong>Competing bid:</strong>
                </h5>
                <p>
                    During a sale, the auctioneer may be accepting competing bids for an item from various sources;
                    these include (but are not limited to):
                </p>
                <ul>
                    <li>bids from an in-house audience</li>
                    <li>telephone bids</li>
                    <li>book bids</li>
                    <li>absentee bids</li>
                    <li>other bidding platforms</li>
                </ul>
                <h5>
                    <strong>Commission:</strong>
                </h5>
                <p>
                    The fee charged to the seller by the auctioneer for providing services–usually a percentage of the
                    gross selling price of the property established by contract (the listing agreement) prior to the
                    auction.{' '}
                </p>

                <h5>
                    <strong>Consignee:</strong>
                </h5>
                <p>
                    The auctioneer or auction house operator to whom goods are entrusted by another (consignor) for sale
                    at auction.{' '}
                </p>

                <h5>
                    <strong>Consignor:</strong>
                </h5>
                <p>
                    The person or authorized agent or entity that consigns goods to an auctioneer. The consignor is
                    usually the seller.{' '}
                </p>

                <h5>
                    <strong>Escrow:</strong>
                </h5>
                <p>Money held in trust by a third party until the seller makes delivery of merchandise to the buyer.</p>

                <h5>
                    <strong>Estate Auction:</strong>
                </h5>
                <p>
                    The sale of property left by a person at his/her death. An estate auction can involve the sale of
                    personal and/or real property.
                </p>

                <h5>
                    <strong>Grading:</strong>
                </h5>
                <p>
                    The process for determining the physical condition of an item. Different items have different
                    grading systems.
                </p>

                <h5>
                    <strong>Hammer Price:</strong>
                </h5>
                <p>
                    Price established by the last bidder and acknowledged by the auctioneer before dropping the hammer
                    or gavel to indicate a sale is completed.
                </p>

                <h5>
                    <strong>Lien:</strong>
                </h5>
                <p>
                    An adverse claim or charge against an item when that item is being used as collateral for a
                    debt.{' '}
                </p>

                <h5>
                    <strong>Lot:</strong>
                </h5>
                <p>
                    An item or set of items for sale in an auction, lots are normally denoted by a &quot;lot&quot;
                    number.
                </p>

                <h5>
                    <strong>National Auctioneers Association:</strong>
                </h5>
                <p>
                    A U.S. association of individual auctioneers united to maintain ethical standards for the auction
                    profession; promote the enactment of just and reasonable laws, ordinances and regulations affecting
                    auction selling; make the public more aware of the advantages of auction selling; and generally
                    improve the business conditions affecting the auction profession.{' '}
                </p>

                <h5>
                    <strong>Online/Virtual Auction:</strong>
                </h5>
                <p>
                    An auction that is for online bidders only and is not conducted in front of a traditional live
                    audience. These auction types may have reserve items in which the auctioneers bid in order to
                    protect the reserve.
                </p>

                <h5>
                    <strong>On-site Auction:</strong>
                </h5>
                <p>An auction conducted on the premises of the property being sold. </p>

                <h5>
                    <strong>On-site Bidder:</strong>
                </h5>
                <p>A bidder who is physically participating at the auction venue.</p>

                <h5>
                    <strong>Outbid:</strong>
                </h5>
                <p>To submit a maximum bid that is higher than another buyer&apos;s maximum bid. </p>

                <h5>
                    <strong>Preview:</strong>
                </h5>
                <p>
                    Specified date and time a property is available for prospective buyer viewing and audits in advance
                    of the sale. Also known as open house or inspection.
                </p>

                <h5>
                    <strong>Reserve or Reserve Price:</strong>
                </h5>
                <p>
                    The minimum price that a seller is willing to accept for an item to be sold at auction. This amount
                    is never formally disclosed.
                </p>

                <h5>
                    <strong>SMS Alerts:</strong>
                </h5>
                <p>
                    Alerts sent via text message to your mobile device to inform you when another bidder has placed a
                    bid on an item.
                </p>

                <h5>
                    <strong>Starting Price:</strong>
                </h5>
                <p>The likely starting bid for a given auction, set by the seller at the time of listing.</p>

                <h5>
                    <strong>Traditional Auction:</strong>
                </h5>
                <p>
                    An auction that is conducted in front of a live audience at a physical location where the items for
                    sale are located.
                </p>
            </div>
        </StyledPageContainer>
    );
};

export default TerminologyPage;

const StyledPageContainer = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    padding: 0 20px 30px;

    p {
        margin: 0 0 20px;
    }
`;
